import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Unlock = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="unlock icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C10.067 3 8.5 4.567 8.5 6.5V10H19C20.1046 10 21 10.8954 21 12V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V12C3 10.8954 3.89543 10 5 10H5.5V6.5C5.5 2.91015 8.41015 0 12 0C13.8061 0 15.4425 0.738618 16.6188 1.92656C17.2017 2.51522 17.1971 3.46495 16.6084 4.04785C16.0198 4.63076 15.07 4.62609 14.4871 4.03743C13.8511 3.39514 12.9731 3 12 3ZM14 15.5C14 16.2403 13.5978 16.8866 13 17.2324V19.5C13 20.0523 12.5523 20.5 12 20.5C11.4477 20.5 11 20.0523 11 19.5V17.2324C10.4022 16.8866 10 16.2403 10 15.5C10 14.3954 10.8954 13.5 12 13.5C13.1046 13.5 14 14.3954 14 15.5Z"
    />
  </svg>
)
